import { render, staticRenderFns } from "./SChart.vue?vue&type=template&id=07a1c751"
import script from "./SChart.vue?vue&type=script&lang=js"
export * from "./SChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports